import React, { useState } from "react";
import { RiMailFill, RiLock2Fill, RiShieldKeyholeLine } from "react-icons/ri";
import Axios from "../../Axios";
import { Modal, MyInput } from "../../ui";

const PRIMARY = "#4f46e5";
const PRIMARY_DARK = "#3730a3";

const btnStyle = (disabled) => ({
  width: "100%",
  height: 46,
  border: "none",
  borderRadius: 10,
  background: disabled ? "#c7c9d9" : PRIMARY,
  color: "#fff",
  fontSize: 15,
  fontWeight: 600,
  cursor: disabled ? "not-allowed" : "pointer",
  transition: "background 0.15s",
});

const StepDots = ({ step }) => (
  <div style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 20 }}>
    {[1, 2, 3].map((n) => (
      <div
        key={n}
        style={{
          width: n === step ? 24 : 8,
          height: 8,
          borderRadius: 4,
          background: n <= step ? PRIMARY : "#e2e3ef",
          transition: "all 0.2s",
        }}
      />
    ))}
  </div>
);

const ForgotPassModal = ({ visible, setVisible }) => {
  const [step, setStep] = useState(1);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState("");

  const resetAll = () => {
    setStep(1);
    setEmail("");
    setOtp("");
    setPassword("");
    setRepassword("");
    setErrorText("");
  };

  const closeModal = () => {
    setVisible(false);
    resetAll();
  };

  const handleSendEmail = async () => {
    setErrorText("");
    try {
      setLoading(true);
      await Axios.post("/auth/forgot-password", { email });
      setStep(2);
    } catch (err) {
      setErrorText(err.response?.data?.message || "Алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    setErrorText("");
    try {
      setLoading(true);
      await Axios.post("/auth/verify-forgot-otp", { email, code: otp });
      setStep(3);
    } catch (err) {
      setErrorText("Код буруу байна");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setErrorText("");
    if (password.length < 8) {
      setErrorText("Нууц үг хамгийн багадаа 8 тэмдэгт байна");
      return;
    }
    if (password !== repassword) {
      setErrorText("Нууц үг таарахгүй байна");
      return;
    }

    try {
      setLoading(true);
      await Axios.put("/auth/reset-password", { email, password });
      alert("Нууц үг амжилттай солигдлоо");
      closeModal();
    } catch (err) {
      setErrorText(err.response?.data?.message || "Алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  const titles = {
    1: "Нууц үг сэргээх",
    2: "Баталгаажуулах код",
    3: "Шинэ нууц үг",
  };

  const subtitles = {
    1: "Бүртгэлтэй и-мэйл хаягаа оруулна уу",
    2: `${email} рүү 6 оронтой код илгээгдлээ`,
    3: "Шинэ нууц үгээ оруулна уу",
  };

  return (
    <Modal visible={visible} onCancel={closeModal}>
      <div style={{ padding: "28px 28px 24px", width: 380, maxWidth: "100%" }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: `${PRIMARY}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
            color: PRIMARY,
            fontSize: 28,
          }}
        >
          <RiShieldKeyholeLine />
        </div>

        <h3
          style={{
            textAlign: "center",
            margin: "0 0 6px",
            fontSize: 20,
            fontWeight: 700,
            color: "#111",
          }}
        >
          {titles[step]}
        </h3>
        <p
          style={{
            textAlign: "center",
            margin: "0 0 20px",
            fontSize: 13,
            color: "#6b7280",
          }}
        >
          {subtitles[step]}
        </p>

        <StepDots step={step} />

        {step === 1 && (
          <>
            <MyInput
              icon={<RiMailFill />}
              placeholder="И-Мэйл"
              value={email}
              onChange={(e) => setEmail(e.target.value.trim().toLowerCase())}
            />
            {errorText && (
              <p style={{ color: "#dc2626", fontSize: 13, margin: "10px 0 0", textAlign: "center" }}>
                {errorText}
              </p>
            )}
            <div style={{ marginTop: 20 }}>
              <button
                style={btnStyle(loading || !email)}
                onClick={handleSendEmail}
                disabled={loading || !email}
              >
                {loading ? "Түр хүлээнэ үү..." : "Код авах"}
              </button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <input
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="000000"
              value={otp}
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 6);
                setOtp(onlyDigits);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && otp.length === 6) handleVerifyOTP();
              }}
              maxLength={6}
              autoFocus
              style={{
                width: "100%",
                height: 56,
                fontSize: 28,
                letterSpacing: 12,
                textAlign: "center",
                fontWeight: 600,
                border: "1.5px solid #e2e3ef",
                borderRadius: 10,
                outline: "none",
                boxSizing: "border-box",
                color: "#111",
              }}
              onFocus={(e) => (e.target.style.borderColor = PRIMARY)}
              onBlur={(e) => (e.target.style.borderColor = "#e2e3ef")}
            />
            {errorText && (
              <p style={{ color: "#dc2626", fontSize: 13, margin: "10px 0 0", textAlign: "center" }}>
                {errorText}
              </p>
            )}
            <div style={{ marginTop: 20 }}>
              <button
                style={btnStyle(loading || otp.length !== 6)}
                onClick={handleVerifyOTP}
                disabled={loading || otp.length !== 6}
              >
                {loading ? "Шалгаж байна..." : "Баталгаажуулах"}
              </button>
            </div>
            <p
              style={{
                textAlign: "center",
                fontSize: 12,
                color: "#9ca3af",
                marginTop: 14,
              }}
            >
              Хэрэв код ирэхгүй байвал spam-аа шалгаарай.
            </p>
          </>
        )}

        {step === 3 && (
          <>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <MyInput
                icon={<RiLock2Fill />}
                placeholder="Шинэ нууц үг"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <MyInput
                icon={<RiLock2Fill />}
                placeholder="Нууц үг давтах"
                type="password"
                value={repassword}
                onChange={(e) => setRepassword(e.target.value)}
              />
            </div>
            {errorText && (
              <p style={{ color: "#dc2626", fontSize: 13, margin: "10px 0 0", textAlign: "center" }}>
                {errorText}
              </p>
            )}
            <div style={{ marginTop: 20 }}>
              <button
                style={btnStyle(loading || !password || !repassword)}
                onClick={handleResetPassword}
                disabled={loading || !password || !repassword}
              >
                {loading ? "Хадгалж байна..." : "Сэргээх"}
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ForgotPassModal;
